{#if config.isEditMode && config.canAdminGeneral}
    <CourseInfoBoxEditView />
{:else}
    <CourseInfoBoxReadView>
        <slot name="custom" slot="custom" />
    </CourseInfoBoxReadView>
{/if}

<script>
    import CourseInfoBoxEditView from "./CourseInfoBoxEditView.svelte";
    import CourseInfoBoxReadView from "./CourseInfoBoxReadView.svelte";

    import config from "../../config";
</script>
